import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Row, Col, Collapse, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { number, object, array, func } from 'prop-types';
import { streams } from '../../../../services/ApiService';
import Card from '@components/Card/Card';
import FlowPostbackMethod from '@themes/4/components/Postback/FlowPostbackMethod';
import FlowPostbackUrl from '@components/Flow/FlowPostbackUrl';
import FlowPostbackStatuses from '@themes/4/components/Flow/FlowPostbackStatuses';
import FlowPixels from '@components/Flow/FlowPixels';
import AlertModal from '@modals/AlertModal/AlertModal';
import { FMessage } from '@hoc/IntlComponents';
import GlobalPostbackPresets from '@themes/4/components/Postback/GlobalPostbackPresets';

class FlowPostback extends PureComponent {
  static propTypes = {
    pixels: array.isRequired,
    streamPixels: array.isRequired,
    statuses: array.isRequired,
    streamStatuses: array.isRequired,
    postback: object,
    streamId: number,
    onPostbackChange: func,
    onPixelChange: func,
    onStatusChange: func,
  };

  static defaultProps = {
    pixels: [],
    streamPixels: [],
    statuses: [],
    streamStatuses: [],
  };

  state = {
    loading: false,
    collapsed: true,
    modal: false,
    errorModal: false,
    postback: {
      method: 0,
      url: '',
    },
    response: '',
    error: '',
    showPostbackHint: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { postback } = nextProps;

    if (postback) {
      this.setState(() => ({ postback }));
    }
  }

  togglePostback = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  };

  toggleErrorModal = () => {
    this.setState(prevState => ({ errorModal: !prevState.errorModal }));
  };

  handlePostbackChange = data => {
    this.setState(
      prevState => ({
        postback: {
          ...prevState.postback,
          ...data,
        },
      }),
      () => {
        this.props.onPostbackChange(this.state.postback);
      },
    );
  };

  checkPostback = () => {
    const { postback } = this.state;

    this.setState(() => ({ loading: true }));

    streams
      .checkPostback(postback)
      .then(({ items }) => {
        const data = items[0];

        this.setState(() => ({
          loading: false,
          response: data.response,
        }));

        this.toggleModal();
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error, code } = response.data.error;
          if (code !== 429) {
            this.setState(() => ({
              errorModal: true,
              error: error.message,
              loading: false,
            }));
          } else {
            this.setState(() => ({
              loading: false,
            }));
          }
        }
      });
  };

  onPresetApply = url => {
    this.handlePostbackChange({ url });
  };

  togglePostbackHint = () =>
    this.setState(prevState => ({ showPostbackHint: !prevState.showPostbackHint }));

  render() {
    const {
      loading,
      postback,
      collapsed,
      modal,
      response,
      errorModal,
      error,
      showPostbackHint,
    } = this.state;
    const {
      pixels,
      statuses,
      streamId,
      streamPixels,
      streamStatuses,
      className,
      showFlowExtraSettings,
    } = this.props;

    return (
      <Fragment>
        {/* Postback method and URL */}
        {pixels && statuses.length > 0 && showFlowExtraSettings && (
          <Fragment>
            <FlowPostbackStatuses
              onStatusChange={this.props.onStatusChange}
              statuses={statuses}
              selected={streamStatuses}
            />
            <FlowPixels
              selected={streamPixels}
              pixels={pixels}
              onPixelChange={this.props.onPixelChange}
            />
          </Fragment>
        )}
        <Button
          onClick={() => this.togglePostbackHint()}
          color="link"
          className="no-padding mb-3 postback-extra-settings-btn"
        >
          <FMessage id="postback.global.title" />
        </Button>
        {showPostbackHint && (
          <p>
            <FormattedMessage id="flow.form.global-postback.hint.theme_4" />{' '}
            <Link to="/tools/global-postback"><FormattedMessage id="flow.form.global-postback.hint.link.theme_4" /></Link>
          </p>
        )}
        <GlobalPostbackPresets onPresetApply={this.onPresetApply} />
        <FlowPostbackMethod
          method={postback.method}
          onPostbackMethodChange={this.handlePostbackChange}
        />
        <FlowPostbackUrl
          theme={4}
          url={postback.url}
          onCheckPostback={this.checkPostback}
          onUrlChange={this.handlePostbackChange}
        />
        <ul className="postback-links list-inline no-margin">
          <li className="list-inline-item">
            <Link to="/faq/tools/flows/postback">
              <FormattedMessage id="flow.form.postback.help" defaultMessage="Help" />
            </Link>
          </li>

          {streamId && (
            <li className="list-inline-item">
              <Link to={`/postback/${streamId}`}>
                <FormattedMessage id="flow.form.postback.logs" defaultMessage="Logs" />
              </Link>
            </li>
          )}

          <li className="list-inline-item"></li>
        </ul>
        <Modal size="lg" isOpen={modal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            <FormattedMessage id="flow.modal.postback-response" defaultMessage="Postback reponse" />
          </ModalHeader>
          <ModalBody>
            <pre>{response}</pre>
          </ModalBody>
        </Modal>
        <AlertModal open={errorModal} message={error} onClose={this.toggleErrorModal} />
      </Fragment>
    );
  }
}

export default FlowPostback;
